import type { BoardIndicator, BoardLayout } from "./boardLayout";
import type { PlacedNode } from "./BoardNodes";
import { edgeIndicator, onBoard } from "./focusFit";
import type { Size } from "./layout";
import type { Bounds, View } from "./viewport";

/** The laid-out board's extent (nodes and options, radius included). */
export function contentBounds(layout: BoardLayout): Bounds | null {
  const all = [...layout.nodes, ...layout.options];
  if (all.length === 0) return null;
  return {
    x0: Math.min(...all.map((n) => n.px - n.r)),
    y0: Math.min(...all.map((n) => n.py - n.r)),
    x1: Math.max(...all.map((n) => n.px + n.r)),
    y1: Math.max(...all.map((n) => n.py + n.r)),
  };
}

/** Edge arrows toward the start/target when the player's view leaves them off-screen. */
export function viewIndicators(
  nodes: PlacedNode[],
  view: View,
  size: Size,
): BoardIndicator[] {
  const out: BoardIndicator[] = [];
  for (const n of nodes) {
    if (!n.endpoint) continue;
    const p = { px: view.k * n.px + view.x, py: view.k * n.py + view.y };
    if (!onBoard(p, size)) {
      out.push({ ...edgeIndicator(n.id, p, size), endpoint: n.endpoint });
    }
  }
  return out;
}
